import { render, staticRenderFns } from "./PurchaseRequestApprovalModal.vue?vue&type=template&id=2c2b6ef3"
import script from "./PurchaseRequestApprovalModal.vue?vue&type=script&lang=js"
export * from "./PurchaseRequestApprovalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports